import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { theme } from 'venuescanner-js/theme';
import { Stack, InputBase, InputLabel } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { UsersIcon } from 'venuescanner-js/react/components/Objects/Icons/FeatherIcons';

const StackStyled = styled(Stack)(() => ({
  [theme.breakpoints.up('md')]: {
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    paddingLeft: '15px',
    marginBottom: '3px',
  },

  [theme.breakpoints.down('md')]: {
    padding: '15px 0',
    width: '100%',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
}));

const InputBaseStyled = styled(InputBase)(() => ({
  ['& .MuiInputBase-input:hover']: {
    borderBottom: '2px solid #000000de',
    marginBottom: '-2px',
  },

  ['& .MuiInputBase-input:focus']: {
    borderBottom: '2px solid #4700D7',
    marginBottom: '-2px',
  },
}));

const ErrorTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.red,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.red,
    fontSize: '12px',
    fontWeight: '400',
    letterSpacing: '0.15px',
    lineHeight: '18px',
  },
}));

const GuestsFieldMui = ({ value, onChange, onFocus, error, register }) => {
  if (!error) {
    error = { show: false, message: '' };
  }

  return (
    <StackStyled direction='row' alignItems='center' spacing={2}>
      <UsersIcon />
      <Stack>
        <InputLabel
          sx={{ marginBottom: { xs: '6px', md: '0px' } }}
          htmlFor='guests-input'>
          GUESTS
        </InputLabel>
        <ErrorTooltip
          title={error.message}
          open={error.show}
          name='capacity-error'
          arrow>
          <InputBaseStyled
            type='number'
            id='guests-input'
            value={value}
            onChange={onChange}
            placeholder='Number of guests'
            inputProps={{
              'aria-label': 'Number of guests',
              ...register('capacity', { required: false }),
            }}
            onFocus={onFocus}
          />
        </ErrorTooltip>
      </Stack>
    </StackStyled>
  );
};

GuestsFieldMui.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.object,
  register: PropTypes.func,
};

export default GuestsFieldMui;
